const subscriptionNames = [
    "AI Model Building",
    "Real-time Surveillance",
    "Product Pricing"
];

export default subscriptionNames;